import { ComponentSize } from '../../../types';
import { Avatar } from '../Avatar';
import { FavoriteIcon } from '../FavoriteIcon';
import { AvatarWithFavoriteProps } from './AvatarWithFavorite.types';

const AvatarWithFavorite = ({
  isFavorited,
  label,
  size = ComponentSize.MEDIUM,
  ...iconProps
}: AvatarWithFavoriteProps) => {
  return (
    <div className="relative">
      <Avatar label={label} size={size} />
      {isFavorited !== undefined && (
        <div className="absolute bottom-[-2px] right-[-2px]">
          <FavoriteIcon isFavorited={isFavorited} size={size} {...iconProps} />
        </div>
      )}
    </div>
  );
};

export default AvatarWithFavorite;
